import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, Link, useParams } from 'react-router-dom';
import { VoucherContainer, Profile } from "./VoucherStyled";
import { FormattedMessage } from 'react-intl';

import { UserContext } from "../../context/userContext";
import { LangContext } from "../../context/langContext";

import back from './../../utils/images/arrow_back.svg';
import print from './../../utils/images/print.svg';
import avatar from './../../utils/images/avatar_fluincr.png';

import { getCollaborationById } from "../../api/collaborationApi";
import { fill, formatNumber } from "../../services/generalSevices";
import { formatDateLocal, fromUTCtoLocal, newFormat, toUTCString } from "../../services/dateServices";
import Spinner from "../../components/Spinner/Spinner";
import CompanyCardVoucher from "../../components/CompanyCardVoucher/CompanyCardVoucher";
import { getAllCompanies } from "../../api/companyApi";

import ReactToPrint from 'react-to-print';

export default function Voucher() {

    const navigate = useNavigate();
    const { idCollaboration } = useParams();

    const divPrintRef = useRef(null);

    const { locale } = useContext(LangContext);

    const { userType, userToken, imageProfile, name, lastName, companyName, city, country, address, phone, indicativePhone, email, typeIdentification, identification, companyId, account } = useContext(UserContext);

    const [isLoading, setIsLoading] = useState(true);
    const [limit, setLimit] = useState(5);
    const [companies, setCompanies] = useState([]);

    const [voucherNumber, setVoucherNumber] = useState(0);
    const [collaborationDate, setCollaborationDate] = useState('');
    const [collaborationTotal, setCollaborationTotal] = useState(0);
    const [collaborationTaxes, setCollaborationTaxes] = useState(0);
    const [collaborationDiscount, setCollaborationDiscount] = useState(0);

    const [companyData, setCompanyData] = useState({});
    const [productData, setProductData] = useState({});

    const [collaborationContents, setCollaborationContents] = useState([]);
    const [sendGift, setSendGift] = useState(false);
    const [giftValue, setGiftValue] = useState(0);
    const [paypalOrderId, setPaypalOrderId] = useState();

    useEffect(() => {

        getAllCompanies({ limit: limit, offset: 0 }).then(({ data, pagination }) => {
            setCompanies(data)
        })

        if (userToken !== null) {
            getCollaborationById({ collaborationId: idCollaboration, token: userToken }).then((response) => {
                setVoucherNumber(response.id)
                setCollaborationDate(response.creation);
                setCollaborationTotal(response.totalPrice);
                setCompanyData(response.company);
                setProductData(response.product);
                setCollaborationContents(response.item)
                setSendGift(response.gift);
                setGiftValue(response.giftValue);
                setPaypalOrderId(response?.paypalorder_id);

                if (response.message === 'error') {
                    navigate('/error')
                }

                setIsLoading(false);
            })
        }


    }, [userToken, idCollaboration])


    /* function printDiv(nombreDiv) {
        var contenido = document.getElementById(nombreDiv).innerHTML;
        var contenidoOriginal = document.body.innerHTML;

        document.body.innerHTML = contenido;

        window.print();

        document.body.innerHTML = contenidoOriginal;
    } */

    return (
        <VoucherContainer>
            <hr className="firstLine" />
            <div className="goBack" onClick={() => navigate(-1)}  >
                <img src={back} alt="go back" className="backIcon" />
                <p>
                    <FormattedMessage id="go_back" defaultMessage="ir atrás" />
                </p>
            </div>
            {(isLoading) ? (<Spinner />) : (
                <div className="voucherBody" id='voucherPrint'>
                    <section className="voucher" id='voucherPrint' >

                        <h2 className="voucherTitle"> <FormattedMessage id="voucher_title_b" defaultMessage="Voucher de tu colaboración" /></h2>

                        <div className="voucherData">

                            <div className="information">
                                <p className="subtitle"><FormattedMessage id="voucher_text_1_b" defaultMessage="Voucher #" />
                                    {fill(voucherNumber, 8)}</p>
                                <div className="userData">
                                    <div className="profile">
                                        <Profile image={imageProfile ? imageProfile : avatar} />
                                        <p className="name" style={{ textTransform: 'capitalize' }}>{(userType === 'influencer') ? (`${name} ${lastName}`) : (companyName)}</p>
                                    </div>
                                    <div className="data">
                                        <p className="accountId"><FormattedMessage id="voucher_text_2" defaultMessage="Cuenta #" />{account}</p>
                                        <p>{city && `${city}, `}{(locale === 'es-CO') ? (country.nombre) : (country.name)}</p>
                                        <p>{address}</p>
                                        <p>ID {(identification !== '') && identification}</p>
                                        {/* <p>{(phone !== '' && phone !== null) && (<span>{`+(${indicativePhone}) ${phone}`}</span>)}</p>
                                        <p>{email}</p> */}
                                    </div>

                                </div>
                            </div>

                            <div className="prices">
                                <div className="subtitle">
                                    {(collaborationDate !== '') && (<p className="date">{/* {formatDateLocal(fromUTCtoLocal(collaborationDate))} */}{newFormat(collaborationDate)}</p>
                                    )}

                                    <ReactToPrint
                                        trigger={() => <button className="printButton"><img src={print} alt="print" className="print" /></button>}
                                        content={() => divPrintRef.current}
                                    />
                                    {/* <img src={print} alt="print" className="print" onClick={() => { printDiv('voucherPrint') }} /> */}

                                </div>

                                <table>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_3" defaultMessage="Subtotal" /></td>
                                        <td className="price">$ {formatNumber(collaborationTotal)}</td>

                                    </tr>

                                    <tr>
                                        <td><FormattedMessage id="voucher_text_4" defaultMessage="Impuestos" /></td>
                                        <td className="price">$ {formatNumber(collaborationTaxes)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_5" defaultMessage="Descuento" /></td>
                                        <td className="price">- $ {formatNumber(collaborationDiscount)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_6" defaultMessage="Total" /></td>
                                        <td className="price">$ {formatNumber(collaborationTotal - collaborationTaxes - collaborationDiscount)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_7" defaultMessage="Pago" /> #{paypalOrderId}</td>
                                        <td className="price">($ {formatNumber(collaborationTotal - collaborationTaxes - collaborationDiscount)})</td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <hr />

                        <div className="companyData">
                            <div className="profile">
                                <Profile image={companyData.imageProfile ? companyData.imageProfile : avatar} />
                                <p className="name" style={{ textTransform: 'capitalize' }}>{companyData.nameCompany}</p>
                            </div>
                            <div className="companyDetails">

                                <p className="accountId"><FormattedMessage id="voucher_text_2" defaultMessage="Cuenta #" />{companyData.account}</p>
                                <p>{companyData?.city && `${companyData.city}, `}{(locale === 'es-CO') ? (companyData?.country?.nombre) : (companyData?.country?.name)}</p>
                                <p>{companyData?.address}</p>
                                <p>NIT {companyData?.attributes?.numberId}</p>
                                {/* <p>{companyData?.phoneNumber && (<span>{`+(${companyData?.indicative})`} {companyData.phoneNumber}</span>)}</p>
                                <p>{companyData?.mail}</p> */}

                            </div>
                        </div>
                        <div className="collaborationData">
                            <div className="profile">
                                <Profile image={(productData.image !== null) ? (productData.image) : avatar} />
                                <p className="name" style={{ textTransform: 'capitalize' }}>{productData.name}</p>
                            </div>
                            <table>

                                {collaborationContents.map((item) => {
                                    return (<tr>
                                        <td><FormattedMessage id="voucher_text_9" defaultMessage="Contenido #" /> {fill(item.id)} <span style={{ textTransform: 'capitalize' }}>({(locale === 'es-CO') ? (JSON.parse(item.title).nombre) : (JSON.parse(item.title).name)})</span></td>
                                        <td className="price">$ {formatNumber(item.price)}</td>
                                    </tr>)
                                })}

                                {/* <tr>
                                    <td><FormattedMessage id="voucher_text_10" defaultMessage="Promoción" /> xx%</td>
                                    <td className="price">$ 0</td>
                                </tr> */}

                                <tr>
                                    <td><FormattedMessage id="voucher_text_11" defaultMessage="Producto/servicio gratuito" /></td>
                                    {(sendGift) ? (<td className="price">- $ {formatNumber(giftValue)}</td>) : (<td className="price">- $ 0</td>)}

                                </tr>
                            </table>

                        </div>
                    </section>

                    <hr className="verticalLine" />

                    <section className="featured">
                        <h3 className="subtitle"><FormattedMessage id="voucher_subtitle_1" defaultMessage="¿Estás listo para tu próxima colaboración?" /></h3>

                        <p className="featuredSubtitle"><FormattedMessage id="voucher_subtitle_3" defaultMessage="Influencers destacados" /></p>

                        <div className="content">
                            <Link to={"/companies"}>
                                <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                            </Link>
                            <div className="cards influencers">

                                {companies.map((company) => (
                                    <CompanyCardVoucher company={company} key={company.id} page='voucher' />
                                ))}
                            </div>
                        </div>

                    </section>

                    {/**-----------TO PRINT------------ */}
                    <section className="voucherToPrint" ref={divPrintRef} >

                        <h2 className="voucherTitle"> <FormattedMessage id="voucher_title_b" defaultMessage="Voucher de tu colaboración" /></h2>
                        <br />
                        <div className="voucherData">

                            <div className="information">
                                <p className="subtitle"><FormattedMessage id="voucher_text_1_b" defaultMessage="Voucher #" />
                                    {fill(voucherNumber, 8)}</p>
                                <div className="userData">
                                    <div className="profile">
                                        <Profile image={imageProfile ? imageProfile : avatar} />
                                        <p className="name" style={{ textTransform: 'capitalize' }}>{(userType === 'influencer') ? (`${name} ${lastName}`) : (companyName)}</p>
                                    </div>

                                    <div className="data">
                                        <p className="accountId"><FormattedMessage id="voucher_text_2" defaultMessage="Cuenta #" />{account}</p>
                                        <p>{city && `${city}, `}{(locale === 'es-CO') ? (country.nombre) : (country.name)}</p>
                                        <p>{address}</p>
                                        <p>ID {(identification !== '') && identification}</p>
                                        {/* <p>{(phone !== '' && phone !== null) && (<span>{`+(${indicativePhone}) ${phone}`}</span>)}</p>
                                        <p>{email}</p> */}
                                    </div>

                                </div>
                            </div>

                            <div className="prices">
                                <div className="subtitle">
                                    {(collaborationDate !== '') && (<p className="date">{/* {formatDateLocal(fromUTCtoLocal(collaborationDate))} */}{newFormat(collaborationDate)}</p>
                                    )}
                                </div>

                                <table>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_3" defaultMessage="Subtotal" /></td>
                                        <td className="price">$ {formatNumber(collaborationTotal)}</td>

                                    </tr>

                                    <tr>
                                        <td><FormattedMessage id="voucher_text_4" defaultMessage="Impuestos" /></td>
                                        <td className="price">$ {formatNumber(collaborationTaxes)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_5" defaultMessage="Descuento" /></td>
                                        <td className="price">- $ {formatNumber(collaborationDiscount)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_6" defaultMessage="Total" /></td>
                                        <td className="price">$ {formatNumber(collaborationTotal - collaborationTaxes - collaborationDiscount)}</td>
                                    </tr>
                                    <tr>
                                        <td><FormattedMessage id="voucher_text_7" defaultMessage="Pago" /> #{paypalOrderId}</td>
                                        <td className="price">($ {formatNumber(collaborationTotal - collaborationTaxes - collaborationDiscount)})</td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <br />
                        <hr />
                        <br />

                        <div className="companyData">
                            <div className="profile">
                                <Profile image={(companyData.imageProfile !== null) ? (companyData.imageProfile) : avatar} />
                                <p className="name" style={{ textTransform: 'capitalize' }}>{companyData.nameCompany}</p>
                            </div>
                            <br />
                            <div className="companyDetails">

                                <p className="accountId"><FormattedMessage id="voucher_text_2" defaultMessage="Cuenta #" />{companyData.account}</p>
                                <p>{companyData?.city && `${companyData.city}, `}{(locale === 'es-CO') ? (companyData?.country?.nombre) : (companyData?.country?.name)}</p>
                                <p>{companyData?.address}</p>
                                <p>NIT {companyData?.attributes?.numberId}</p>
                                {/* <p>{companyData?.phoneNumber && (<span>{`+(${companyData?.indicative})`} {companyData.phoneNumber}</span>)}</p>
                                <p>{companyData?.mail}</p> */}

                            </div>
                        </div>
                        <div className="collaborationData">
                            <div className="profile">

                                <Profile image={productData.image ? productData.image : avatar} />
                                <p className="name" style={{ textTransform: 'capitalize' }}>{productData.name}</p>
                            </div>
                            <table>

                                {collaborationContents.map((item) => {
                                    return (<tr>
                                        <td><FormattedMessage id="voucher_text_9" defaultMessage="Contenido #" /> {fill(item.id)} <span style={{ textTransform: 'capitalize' }}>({(locale === 'es-CO') ? (JSON.parse(item.title).nombre) : (JSON.parse(item.title).name)})</span></td>
                                        <td className="price">$ {formatNumber(item.price)}</td>
                                    </tr>)
                                })}

                                {/* <tr>
                                    <td><FormattedMessage id="voucher_text_10" defaultMessage="Promoción" /> xx%</td>
                                    <td className="price">$ 0</td>
                                </tr> */}

                                <tr>
                                    <td><FormattedMessage id="voucher_text_11" defaultMessage="Producto/servicio gratuito" /></td>
                                    {(sendGift) ? (<td className="price">- $ {formatNumber(giftValue)}</td>) : (<td className="price">- $ 0</td>)}

                                </tr>
                            </table>

                        </div>
                    </section>

                </div>
            )}

        </VoucherContainer>
    )
}